import { render, staticRenderFns } from "./templateConfiguration.vue?vue&type=template&id=7e2640a2&scoped=true&"
import script from "./templateConfiguration.vue?vue&type=script&lang=js&"
export * from "./templateConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./templateConfiguration.vue?vue&type=style&index=0&id=7e2640a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2640a2",
  null
  
)

component.options.__file = "templateConfiguration.vue"
export default component.exports